// import * as constants from '../constants';

// const nms = [ constants.NAMESPACE, 'store', 'state' ].join('/');
// const log = require('debug')('@mycure/vue-plugins/' + nms);

/// imports and local declarations
/**
 * @typedef {import('../../accounts/store/state').PersonalDetails} PersonalDetails
 */

/**
 * TODO: complete the schema based on what properties are used
 * @typedef {Object} Organization
 * @property {string} id
 * @property {number} createdAt
 * @property {string} createdBy
 * @property {string} name
 * @property {string} logoURL
 * @property {string} picURL
 * @property {string} coverURL
 */

/**
 * @typedef {Object} OrganizationMembership
 * @property {string} id
 * @property {string} uid
 * @property {string} organization
 * @property {Organization} facility
 * @property {PersonalDetails} personalDetails
 */

/**
 * @typedef {Object} Clock
 * @property {string} id
 * @property {number} createdAt
 * @property {string} createdBy
 * @property {string} organization
 * @property {string} startAt
 * @property {string} endAt
 */

const state = {
  /**
   * organizations cache
   * @type {Organization[]}
   */
  organizations: [],

  /**
   * current user's list of
   * affiliatied organizations
   * @type {OrganizationMembership[]}
   **/
  currentUserMemberships: [],

  /**
   * current active membership's id
   * @type {string}
   **/
  activeMembershipId: null,

  /**
   * list of members of the current active organization
   * @type {OrganizationMembership[]}
   **/
  activeOrganizationMembers: [],

  /**
   * opening and closing time records
   * @type {Clock[]}
   */
  activeOrganizationOpeningTimes: [],

  /**
   * selected clinic
   * @type {Organization}
   */
  selectedOrganization: null
};

export default state;

/**
 * list of organizations (facilities)
 * available to the current user
 * @param {state} state
 * @returns {Organization[]}
 */
export function currentUserOrganizations (state) {
  return state.currentUserMemberships.map(m => m.facility);
}

/**
 * list of organizations (facilities)
 * available to the current user
 * @param {state} state
 * @returns {OrganizationMembership}
 */
export function activeMembership (state) {
  if (!state.activeMembershipId) return null;
  return state.currentUserMemberships.find(m => m.id === state.activeMembershipId);
}

/**
 * current active organization (facility)
 * @param {state} state
 * @returns {Organization}
 */
export function activeOrganization (state, getters) {
  const membership = getters.activeMembership;
  if (!membership) return null;
  return membership.facility;
}

/**
 * current active organization (facility)
 * @param {state} state
 * @returns {boolean}
 */
export function isActiveOrganizationOpen (state, getters) {
  // organization is open if there is a clock that hasn't been ended
  return state.activeOrganizationOpeningTimes.find(c => !c.endAt);
}
